<template>
  <header class="header">
    <div class="container">
      <a href="/" class="logo">Omni-note</a>
      <nav>
        <div 
          class="nav-links" 
          :class="{ 'active': showMobileMenu }"
          @mouseleave="showMobileMenu = false"
        >
          <router-link to="/" exact-active-class="active" @click="showMobileMenu = false">{{ $t('header.home') }}</router-link>
          <router-link to="/features" exact-active-class="active" @click="showMobileMenu = false">{{ $t('header.features') }}</router-link>
          <router-link to="/download" exact-active-class="active" @click="showMobileMenu = false">{{ $t('header.download') }}</router-link>
          <router-link to="/purchase" exact-active-class="active" @click="showMobileMenu = false">{{ $t('header.buy') }}</router-link>
          <a href="https://api.turingevo.com/" target="_blank" rel="noopener" class="token-link" @click="showMobileMenu = false">{{ $t('header.token') }}</a>
          <router-link to="/blog" exact-active-class="active" @click="showMobileMenu = false">{{ $t('header.blog') }}</router-link>
          <router-link to="/contact" exact-active-class="active" @click="showMobileMenu = false">{{ $t('header.contact') }}</router-link>
        </div>
      </nav>
      <div class="header-actions">
        <select id="language-selector" v-model="$i18n.locale">
          <option value="zh-CN">中文</option>
          <option value="en">English</option>
        </select>
        <div class="user-menu" v-if="isLoggedIn">
          <div class="user-dropdown">
            <button class="user-button" @mouseenter="showUserDropdown = true" @click="toggleUserDropdown">
              {{ truncateUsername(userDisplayName, 10) }}
            </button>
            <div class="dropdown-content" v-show="showUserDropdown" @mouseleave="showUserDropdown = false">
              <router-link to="/profile" class="dropdown-item">{{ $t('profile.title') }}</router-link>
              <router-link to="/order-center" class="dropdown-item">{{ $t('header.order_center') }}</router-link>
              <router-link to="/edit-profile" class="dropdown-item">{{ $t('header.edit_profile') }}</router-link>
              <button class="dropdown-item logout-btn" @click="handleLogout">{{ $t('profile.logout') }}</button>
            </div>
          </div>
        </div>
        <div class="user-menu" v-else>
          <div class="user-dropdown">
            <button class="user-button" @mouseenter="showUserDropdown = true" @click="toggleUserDropdown">
              {{ $t('header.user') }}
            </button>
            <div class="dropdown-content" v-show="showUserDropdown" @mouseleave="showUserDropdown = false">
              <router-link to="/login" class="dropdown-item" @click="closeDropdown">{{ $t('login.login') }}</router-link>
              <router-link to="/register" class="dropdown-item" @click="closeDropdown">{{ $t('register.register') }}</router-link>
            </div>
          </div>
        </div>
        <button 
          class="menu-toggle" 
          @mouseenter="showMobileMenu = true"
          @click="showMobileMenu = !showMobileMenu"
        >
          ☰
        </button>
      </div>
    </div>
  </header>
</template>

<script>

export default {
  name: 'AppHeader',
  data() {
    return {
      isLoggedIn: false,
      showUserDropdown: false,
      showMobileMenu: false,
      userDisplayName: ''
    }
  },
  mounted() {
    // 检查用户是否已登录
    this.checkAuthStatus()
    
    // 监听路由变化，重新检查登录状态
    this.$router.afterEach(() => {
      this.checkAuthStatus()
    })
  },
  methods: {
    checkAuthStatus() {
      // 检查是否有存储的token
      const token = typeof window !== 'undefined' ? window.localStorage.getItem('token') : null
      this.isLoggedIn = !!token
      
      // 如果已登录，获取用户显示名
      if (this.isLoggedIn) {
        try {
          // 首先尝试从user项获取用户信息（AuthModal登录）
          let user = JSON.parse(localStorage.getItem('user') || '{}')
          
          // 如果user项没有数据，尝试从userInfo项获取（Login/Register页面登录）
          if (!user || (typeof user === 'object' && Object.keys(user).length === 0)) {
            const userInfoStr = localStorage.getItem('userInfo')
            if (userInfoStr) {
              const userInfo = JSON.parse(userInfoStr)
              // 解构userInfo中的用户信息
              user = {
                username: userInfo.un || userInfo.username,
                email: userInfo.e || userInfo.email
              }
            }
          }
          
          this.userDisplayName = user.username || user.email || '用户'
        } catch (error) {
          console.error('解析用户信息失败:', error)
          this.userDisplayName = '用户'
        }
      } else {
        this.userDisplayName = ''
      }
    },
    toggleMenu() {
      // 移动端菜单切换
      if (typeof window !== 'undefined') {
        const navLinks = window.document.querySelector('.nav-links');
        navLinks.classList.toggle('active');
      }
    },
    toggleUserDropdown() {
      this.showUserDropdown = !this.showUserDropdown
    },
    closeDropdown() {
      this.showUserDropdown = false
    },
    handleLogout() {
      // 清除本地存储的用户信息和token
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('licenseKey')
      
      // 关闭下拉菜单
      this.showUserDropdown = false
      
      // 刷新页面以更新状态
      this.checkAuthStatus()
      
      // 跳转到首页
      this.$router.push('/')
    },
    truncateUsername(username, maxLength) {
      if (!username) return '';
      if (username.length <= maxLength) return username;
      return username.substring(0, maxLength) + '...';
    }
  }
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #ff5f5f;
  text-decoration: none;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-links a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.nav-links a:hover,
.nav-links a.active {
  background-color: #f0f0f0;
  color: #ff5f5f;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

#language-selector {
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background-color: white;
}

.user-menu {
  position: relative;
}

.user-dropdown {
  position: relative;
}

.user-button {
  padding: 8px 16px;
  border: 1px solid #007bff;
  border-radius: 4px;
  background-color: transparent;
  color: #007bff;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.user-button:hover {
  background-color: #007bff;
  color: white;
}

.dropdown-content {
  position: absolute;
  right: 0;
  top: 100%;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 120px;
  margin-top: 5px;
}

.dropdown-item {
  display: block;
  padding: 10px 15px;
  text-decoration: none;
  color: #333;
  border-bottom: 1px solid #eee;
  transition: background-color 0.3s;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.dropdown-item:last-child {
  border-bottom: none;
}

.logout-btn {
  background: none;
  border: none;
  color: #dc3545;
  text-align: left;
  width: 100%;
  padding: 10px 15px;
  cursor: pointer;
  font-size: inherit;
}

.logout-btn:hover {
  background-color: #f8d7da;
  color: #721c24;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

/* 手机端响应式样式 */
@media (max-width: 768px) {
  .nav-links {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: white;
    flex-direction: column;
    padding: 20px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }
  
  .nav-links.active {
    display: flex;
  }
  
  .menu-toggle {
    display: block;
  }
}
</style>
